import _defineProperty from "@babel/runtime/helpers/defineProperty";
import isHotkey from 'is-hotkey';

function makeKeyboardInlineShortcut(hotkey, type) {
  var isShortcutHotkey = isHotkey(hotkey, {
    byKey: true
  });

  function onKeyDown(event, editor, next) {
    if (!isShortcutHotkey(event)) return next();
    event.preventDefault();
    return typeof type === 'function' ? type(editor) : editor.toggleMark(type);
  }

  return {
    onKeyDown: onKeyDown,
    keyboardShortcut: _defineProperty({}, type, hotkey)
  };
}

export default makeKeyboardInlineShortcut;